export var getDefaultButtonProps = function (btnProps) {
    return {
        className: btnProps.className,
        type: btnProps.type,
        variant: btnProps.variant,
        size: btnProps.size,
    };
};
export var INFOBUBBLE_MODE = {
    SAVE: "save",
    EDIT: "edit",
};
